import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-94292bb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "alert alert-primary d-flex align-items-center",
  role: "alert"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "currentColor",
    class: "bi bi-exclamation-triangle-fill flex-shrink-0 me-2",
    viewBox: "0 0 16 16",
    role: "img",
    "aria-label": "Warning:"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, " An example alert with an icon ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, " Rider Earning Report")
  ])
], -1))
const _hoisted_5 = { class: "col-12 bg-light p-3" }
const _hoisted_6 = { class: "row height d-flex justify-content-center align-items-center" }
const _hoisted_7 = { class: "col-md-3 text-start" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-start" }, "Riders", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "col-md-3 text-start" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "From Date", -1))
const _hoisted_12 = { class: "col-md-3 text-start" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "To Date", -1))
const _hoisted_14 = { class: "col-md-3 text-start" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { class: "table-responsive" }
const _hoisted_19 = { class: "table table-striped table-sm" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Total Orders"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Total Distance"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Total Amount")
  ])
], -1))
const _hoisted_21 = { class: "text-start text-captilize" }
const _hoisted_22 = { class: "text-start" }
const _hoisted_23 = { class: "text-start" }
const _hoisted_24 = { class: "table-responsive" }
const _hoisted_25 = { class: "table table-striped table-sm" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Total"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "PickUp Date"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "City"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Status"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Payment")
  ])
], -1))
const _hoisted_27 = { class: "text-start" }
const _hoisted_28 = { class: "text-start" }
const _hoisted_29 = { class: "text-start" }
const _hoisted_30 = { class: "text-start" }
const _hoisted_31 = { class: "text-start" }
const _hoisted_32 = { class: "text-start" }
const _hoisted_33 = { colspan: "6" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-start" }, "Item Detail", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_37 = { class: "row" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Item Id", -1))
const _hoisted_39 = { class: "col-sm-3 text-end" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Total Cost", -1))
const _hoisted_41 = { class: "col-sm-3 text-end" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Customer Name", -1))
const _hoisted_44 = { class: "col-sm-3 text-end" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-3 text-start fw-bold" }, "Customer Address ", -1))
const _hoisted_46 = { class: "col-sm-3 text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_AdminPagination = _resolveComponent("AdminPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.driver_id) = $event)),
              class: "form-control",
              required: ""
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.riders, (rider) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: rider.id,
                  value: rider.id
                }, _toDisplayString(rider.rider_name) + " (" + _toDisplayString(rider.id) + " ) (" + _toDisplayString(rider.city?.name) + ") ", 9, _hoisted_9))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.driver_id]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_datepicker, {
              modelValue: $setup.fromdate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.fromdate) = $event)),
              class: "form-control"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_datepicker, {
              modelValue: $setup.todate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.todate) = $event)),
              class: "form-control"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              class: "btn btn-sm btn-primary p-2 mt-3",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.searchcall && $setup.searchcall(...args)))
            }, "Search")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        ($setup.summary.length)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-sm btn-primary",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.downloadpdf && $setup.downloadpdf(...args)))
            }, "Download PDF Invoice"))
          : _createCommentVNode("", true),
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("table", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.summary, (record) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: record.orderstatus_id
                }, [
                  _createElementVNode("td", _hoisted_21, _toDisplayString(record.ordercount), 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(record.totaldistance), 1),
                  _createElementVNode("td", _hoisted_23, _toDisplayString(record.totalprice), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("table", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.orders, (order) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: order.id
                }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_27, _toDisplayString(order.id), 1),
                    _createElementVNode("td", _hoisted_28, _toDisplayString(order.total_price), 1),
                    _createElementVNode("td", _hoisted_29, _toDisplayString($options.dateTime(order.pickup_date)), 1),
                    _createElementVNode("td", _hoisted_30, _toDisplayString(order.city?.name), 1),
                    _createElementVNode("td", _hoisted_31, _toDisplayString(order.orderstatus?.name), 1),
                    _createElementVNode("td", _hoisted_32, _toDisplayString(order.paymentmethod?.name), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_33, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.order_items, (orderitem) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: orderitem.id
                        }, [
                          _hoisted_34,
                          _hoisted_35,
                          _hoisted_36,
                          _createElementVNode("div", _hoisted_37, [
                            _hoisted_38,
                            _createElementVNode("div", _hoisted_39, _toDisplayString(orderitem.id), 1),
                            _hoisted_40,
                            _createElementVNode("div", _hoisted_41, _toDisplayString(orderitem.price), 1)
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _hoisted_43,
                            _createElementVNode("div", _hoisted_44, _toDisplayString(orderitem.customer_name), 1),
                            _hoisted_45,
                            _createElementVNode("div", _hoisted_46, _toDisplayString(orderitem.customer_address), 1)
                          ])
                        ], 64))
                      }), 128))
                    ])
                  ])
                ], 64))
              }), 128))
            ])
          ])
        ])
      ]),
      _createVNode(_component_AdminPagination, {
        "last-page": $setup.lastPage,
        onPageChanged: _cache[5] || (_cache[5] = ($event: any) => ($setup.load($event)))
      }, null, 8, ["last-page"])
    ])
  ]))
}